import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
          <div>
            <h3 className="text-xl sm:text-2xl font-bold mb-4">NWA ROOFING</h3>
            <p className="text-gray-400 text-sm sm:text-base mb-6 leading-relaxed">
              Connecting Northwest Arkansas homeowners with trusted, licensed roofing contractors since 1998. Get free quotes from vetted local roofers throughout Fayetteville, Springdale, Rogers, Bentonville, and Bella Vista.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="min-w-[44px] min-h-[44px] flex items-center justify-center border border-gray-600 rounded-full hover:border-orange-500 hover:text-orange-500 transition-colors cursor-pointer touch-manipulation active:scale-95">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="min-w-[44px] min-h-[44px] flex items-center justify-center border border-gray-600 rounded-full hover:border-orange-500 hover:text-orange-500 transition-colors cursor-pointer touch-manipulation active:scale-95">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="min-w-[44px] min-h-[44px] flex items-center justify-center border border-gray-600 rounded-full hover:border-orange-500 hover:text-orange-500 transition-colors cursor-pointer touch-manipulation active:scale-95">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="min-w-[44px] min-h-[44px] flex items-center justify-center border border-gray-600 rounded-full hover:border-orange-500 hover:text-orange-500 transition-colors cursor-pointer touch-manipulation active:scale-95">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 uppercase tracking-wider">SERVICES</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li><Link to="/services/roof-repair" className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors inline-block py-1 touch-manipulation">Roof Repair</Link></li>
              <li><Link to="/services/roof-replacement" className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors inline-block py-1 touch-manipulation">Roof Replacement</Link></li>
              <li><Link to="/services/roof-inspection" className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors inline-block py-1 touch-manipulation">Roof Inspection</Link></li>
              <li><Link to="/services/commercial-roofing" className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors inline-block py-1 touch-manipulation">Commercial Roofing</Link></li>
              <li><Link to="/services/insurance-adjuster" className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors inline-block py-1 touch-manipulation">Insurance Claims</Link></li>
              <li><Link to="/services/emergency-roof-repair" className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors inline-block py-1 touch-manipulation">Emergency Roof Repair</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 uppercase tracking-wider">SERVING NWA</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors cursor-pointer flex items-center py-1 touch-manipulation">
                <i className="ri-arrow-right-s-line mr-2"></i>Fayetteville
              </li>
              <li className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors cursor-pointer flex items-center py-1 touch-manipulation">
                <i className="ri-arrow-right-s-line mr-2"></i>Springdale
              </li>
              <li className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors cursor-pointer flex items-center py-1 touch-manipulation">
                <i className="ri-arrow-right-s-line mr-2"></i>Rogers
              </li>
              <li className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors cursor-pointer flex items-center py-1 touch-manipulation">
                <i className="ri-arrow-right-s-line mr-2"></i>Bentonville
              </li>
              <li className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors cursor-pointer flex items-center py-1 touch-manipulation">
                <i className="ri-arrow-right-s-line mr-2"></i>Bella Vista
              </li>
              <li className="text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors cursor-pointer flex items-center py-1 touch-manipulation">
                <i className="ri-arrow-right-s-line mr-2"></i>Siloam Springs
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 uppercase tracking-wider">CONTACT INFO</h4>
            <div className="space-y-3 sm:space-y-4">
              <a href="tel:4793455312" className="flex items-center text-white hover:text-orange-400 transition-colors touch-manipulation active:scale-95 py-1">
                <i className="ri-phone-fill text-xl sm:text-2xl mr-3"></i>
                <span className="text-lg sm:text-xl font-semibold">(479) 345-5312</span>
              </a>
              <a href="mailto:info@nwaroofing.com" className="flex items-center text-gray-400 text-sm sm:text-base hover:text-orange-400 transition-colors touch-manipulation py-1 break-all">
                <i className="ri-mail-fill text-lg sm:text-xl mr-3 flex-shrink-0"></i>
                <span>info@nwaroofing.com</span>
              </a>
              <div className="flex items-start text-gray-400 text-sm sm:text-base py-1">
                <i className="ri-map-pin-fill text-lg sm:text-xl mr-3 mt-1 flex-shrink-0"></i>
                <span>Serving All of Northwest Arkansas</span>
              </div>
              <div className="bg-orange-600 text-white px-4 py-2.5 sm:py-3 rounded-lg inline-block font-semibold text-sm sm:text-base">
                24/7 Contractor Matching
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer Section */}
        <div className="mt-10 sm:mt-12 pt-6 sm:pt-8 border-t border-gray-700">
          <div className="bg-gray-800/50 rounded-lg p-4 sm:p-6">
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
              <strong className="text-white">Important Disclosure:</strong> NWA Roofing is a lead generation and referral service. We do not perform roofing work directly. All roofing services, installations, repairs, inspections, <strong>storm damage restoration</strong>, and emergency repairs are provided by independent, licensed roofing contractors in the Northwest Arkansas area. We connect homeowners with qualified professionals and are not responsible for the work performed by third-party contractors. Always verify contractor licenses, insurance, and references before hiring.
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center text-xs sm:text-sm text-gray-400 space-y-3 sm:space-y-0">
            <p className="text-center sm:text-left">&copy; 2025 NWA Roofing Referral Service. All rights reserved.</p>
            <div className="flex items-center flex-wrap justify-center gap-x-3 sm:gap-x-4 gap-y-2">
              <Link to="/privacy-policy" className="hover:text-orange-400 transition-colors touch-manipulation py-1">Privacy Policy</Link>
              <span className="hidden sm:inline">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors touch-manipulation py-1">Website Builder</a>
              <span className="hidden sm:inline">|</span>
              <a href="/sitemap.xml" className="hover:text-orange-400 transition-colors touch-manipulation py-1">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;